<template>
    <div v-if="additionals">
        <List
            v-if="additionals.plantaoId"
            :fields="fields"
            :plantao-faixa-etaria-id="additionals.plantaoFaixaEtariaId"
            :setor-tipo-id="enums.setorTipo.TRIAGEM"
            @status-changed="handleStatusChanged"
        >
            <template v-slot:custom-actions="{ item }">
                <rkm-button
                    @click.stop="answer(item)"
                    color="primary"
                    small
                    title="Atender"
                    authorize="store-pronto-atendimento-atendimento-triagem"
                >
                    <rkm-icon icon="plus" />
                </rkm-button>

                <rkm-button
                    color="info"
                    small
                    title="Imprimir"
                    @click="getImpressoes(item.atendimento.id, enums.setorTipo.TRIAGEM)
                        .then(impressoes => $refs.ModalImpressao.open(impressoes, item.atendimento.id))"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    @click="$refs.ModalEvasao.open(item.id)"
                    color="danger"
                    small
                    title="Evadir"
                >
                    <rkm-icon icon="running" />
                </rkm-button>
            </template>
        </List>

        <rkm-alert color="warning" v-else>
            Não existe nenhum plantão cadastrado para este usuário.
        </rkm-alert>

        <ModalEvasao ref="ModalEvasao" />
        <ModalImpressao ref="ModalImpressao" />
    </div>
</template>

<script>
import ModalImpressao from '@/components/pronto-atendimento/impressao/components/impressao/Modal'

import { prontoAtendimentoFila } from '@/mixins'

// Mixins.
import { error, repository } from '@/mixins'

export default {
    components: { ModalImpressao },
    created() {
        this.repositories.triagem = this.getConectaSusRepository('prontoAtendimento.atendimentoTriagem')
    },
    data: () => ({
        additionals: null,
        createRouteName: 'pronto-atendimento-atendimento-triagem-create',
        repositories: {
            triagem: null,
        },
    }),
    methods: {
        load() {
            this.repositories.triagem.index()
                .then(response => {
                    this.additionals = response.data.additionals
                    this.model.currentPlantaoId = this.additionals.plantaoId
                })
                .catch(this.handleError)
        },
    },
    mixins: [ error, prontoAtendimentoFila, repository ],
    mounted() {
        this.load()
    },
}
</script>